/* !
 * tingle.js
 * @version 0.15.2
 * https://github.com/robinparisi/tingle
 * https://github.com/robinparisi/tingle/blob/master/src/tingle.js
 * @url
 */

/* global define,module */
(function(root, factory) {
  if (typeof define === "function" && define.amd) {
    define(factory);
  } else if (typeof exports === "object") {
    module.exports = factory();
  } else {
    root.tingle = factory();
  }
})(this, function() {
  /* ----------------------------------------------------------- */
  /* == modal */
  /* ----------------------------------------------------------- */

  var isBusy = false;

  function Modal(options) {
    var defaults = {
      onClose: null,
      onOpen: null,
      beforeOpen: null,
      beforeClose: null,
      stickyFooter: false,
      footer: false,
      cssClass: [],
      closeLabel: "Close",
      closeIconInverse: false,
      focusAfterClosed: null,
      arialabelledby: null,
      ariadescribedby: null,
      closeMethods: ["overlay", "button", "escape"],
      closeIconLight: false,
      setFocusOnCloseIcon: false,
    };

    // extends config
    this.opts = extend({}, defaults, options);

    // init modal
    this.init();
  }

  Modal.prototype.init = function() {
    if (this.modal) {
      return;
    }

    _build.call(this);
    _bindEvents.call(this);

    // insert modal in dom
    document.body.insertBefore(this.modal, document.body.firstChild);

    if (this.opts.footer) {
      this.addFooter();
    }

    return this;
  };

  Modal.prototype._busy = function(state) {
    isBusy = state;
  };

  Modal.prototype._isBusy = function() {
    return isBusy;
  };

  Modal.prototype.destroy = function() {
    if (this.modal === null) {
      return;
    }

    // restore scrolling
    if (this.isOpen()) {
      this.close(true);
    }

    // unbind all events
    _unbindEvents.call(this);

    // remove modal from dom
    if (this.modal) {
      this.modal.parentNode.removeChild(this.modal);
      
      this.modal = null;
    }

    //reset grecaptcha 
    var captchaFieldExists = false, captchaFieldShow = document.querySelectorAll('.g-recaptcha.show, [data-sitekey]');

    //check parent have bs-modal-body || tingle class
    for (var index = 0; index < captchaFieldShow.length; index++) {
      var element = captchaFieldShow[index];
      if (!element.closest(".bs-modal-body")) {
        captchaFieldExists = true;
        break;
      }
    }

    if (captchaFieldExists && typeof grecaptcha !== "undefined") {
      // Ensure popup can reopen, if reset operation fails due to the absence of the reCAPTCHA widget ID.
      try { 
        grecaptcha.reset();
      } catch (e) {} 
    }
  };

  Modal.prototype.isOpen = function() {
    return !!this.modal.classList.contains("tingle-modal--visible");
  };

  Modal.prototype.open = function() {
    if (this._isBusy()) return;
    this._busy(true);

    var self = this;

    // before open callback
    if (typeof self.opts.beforeOpen === "function") {
      self.opts.beforeOpen();
    }

    if (this.modal.style.removeProperty) {
      this.modal.style.removeProperty("display");
    } else {
      this.modal.style.removeAttribute("display");
    }

    // prevent double scroll
    this._scrollPosition = window.pageYOffset;
    document.body.classList.add("tingle-enabled");
    document.body.style.top = -this._scrollPosition + "px";

    // sticky footer
    this.setStickyFooter(this.opts.stickyFooter);

    // show modal
    this.modal.classList.add("tingle-modal--visible");

    // onOpen callback
    if (typeof self.opts.onOpen === "function") {
      self.opts.onOpen.call(self);
    }

    self._busy(false);

    // check if modal is bigger than screen height
    this.checkOverflow();

    var focusableElements = 'iframe, [href], input, select, textarea, button, [tabindex]:not([tabindex="-1"])',
    firstFocusableElement = this.modal.querySelectorAll(focusableElements)[0], // get first element to be focused inside modal
    closeIconFocusElem = this.modal.querySelector('#tingle-modal__close'); // get close icon focus elem inside modal

    if (this.opts.setFocusOnCloseIcon && closeIconFocusElem) { // set focus for close button
      closeIconFocusElem.focus();
    } else if (firstFocusableElement) {
      firstFocusableElement.focus();
    }

    //show images from lazy load
    lazyLoading.show();

    //checkbox click event
    var checkboxList = document.querySelectorAll("input[type=checkbox]");
    for (var i = 0; i < checkboxList.length; i++) {
      checkboxList[i].addEventListener( 'change', function() {
          if (this.checked) {
            //show images from lazy load
            lazyLoading.show();
          }
      });
    }

    //reset grecaptcha 
    var captchaFieldShow = document.querySelectorAll('.onpage-recaptcha');
    for (var index = 0; index < captchaFieldShow.length; index++) {
      var element = captchaFieldShow[index];
      // Only reset captchas not inside modal
      if (!element.closest(".bs-modal-body")) {
        // Reset reCAPTCHA if widgetId is present
        if (typeof grecaptcha !== "undefined" && element.dataset.gWidgetId) {
          try {
            grecaptcha.reset(parseInt(element.dataset.gWidgetId));
          } catch (e) {}
        }
        // Optionally clear the container
        if (element.innerHTML !== "") {
          element.innerHTML = "";
        }
      }
    }

    return this;
  };

  Modal.prototype.close = function(force) {
    if (this._isBusy()) return;
    this._busy(true);
    force = force || false;

    //  before close
    if (typeof this.opts.beforeClose === "function") {
      var close = this.opts.beforeClose.call(this);
      if (!close) {
        this._busy(false);
        return;
      }
    }

    document.body.classList.remove("tingle-enabled");
    window.scrollTo({
      top: this._scrollPosition,
      behavior: "instant"
    });
    document.body.style.top = null;

    // using similar setup as onOpen
    var self = this;

    if (self.modal) {
      self.modal.classList.remove("tingle-modal--visible");
      self.modal.style.display = "none";
    }

    // onClose callback
    if (typeof self.opts.onClose === "function") {
      self.opts.onClose.call(this);
    }

    // release modal
    self._busy(false);

    //set focus after close
    if (this.opts.focusAfterClosed) {
      var focusAfterClosed = this.opts.focusAfterClosed,
      focusAfterClosedChild = focusAfterClosed.firstElementChild;
      if ( focusAfterClosed.tagName === "DIV" && focusAfterClosedChild) {
        if (focusAfterClosedChild.tagName === "BUTTON" || focusAfterClosedChild.tagName === "A") {
          focusAfterClosed = focusAfterClosedChild;
        }
      }
      focusAfterClosed.focus();
    }

    //reset grecaptcha 
    var captchaFieldExists = false, captchaFieldShow = document.querySelectorAll('.g-recaptcha.show, [data-sitekey]');

    //check parent have bs-modal-body || tingle class
    for (var index = 0; index < captchaFieldShow.length; index++) {
      var element = captchaFieldShow[index];
      if (!element.closest(".bs-modal-body")) {
        captchaFieldExists = true;
        break;
      }
    }

    if (captchaFieldExists && typeof grecaptcha !== "undefined") {
      // Ensure popup can reopen, if reset operation fails due to the absence of the reCAPTCHA widget ID.
      try {
        grecaptcha.reset();
      } catch (e) {} 
    }

    document.getElementById("page__wrapper").setAttribute("aria-hidden", "false");
  };

  Modal.prototype.setContent = function(content) {
    // check type of content : String or Node
    if (typeof content === "string") {
      this.modalBoxContent.innerHTML = content;
    } else {
      this.modalBoxContent.innerHTML = "";
      this.modalBoxContent.appendChild(content);
    }

    if (this.isOpen()) {
      // check if modal is bigger than screen height
      this.checkOverflow();
    }

    return this;
  };

  Modal.prototype.getContent = function() {
    return this.modalBoxContent;
  };

  Modal.prototype.addFooter = function() {
    // add footer to modal
    _buildFooter.call(this);

    return this;
  };

  Modal.prototype.setFooterContent = function(content) {
    // set footer content
    this.modalBoxFooter.innerHTML = content;

    return this;
  };

  Modal.prototype.getFooterContent = function() {
    return this.modalBoxFooter;
  };

  Modal.prototype.setStickyFooter = function(isSticky) {
    // if the modal is smaller than the viewport height, we don't need sticky
    if (!this.isOverflow()) {
      isSticky = false;
    }

    if (isSticky) {
      if (this.modalBox.contains(this.modalBoxFooter)) {
        this.modalBox.removeChild(this.modalBoxFooter);
        this.modal.appendChild(this.modalBoxFooter);
        this.modalBoxFooter.classList.add("tingle-modal-box__footer--sticky");
        _recalculateFooterPosition.call(this);
        this.modalBoxContent.style["padding-bottom"] =
          this.modalBoxFooter.clientHeight + 20 + "px";
      }
    } else if (this.modalBoxFooter) {
      if (!this.modalBox.contains(this.modalBoxFooter)) {
        this.modal.removeChild(this.modalBoxFooter);
        this.modalBox.appendChild(this.modalBoxFooter);
        this.modalBoxFooter.style.width = "auto";
        this.modalBoxFooter.style.left = "";
        this.modalBoxContent.style["padding-bottom"] = "";
        this.modalBoxFooter.classList.remove(
          "tingle-modal-box__footer--sticky"
        );
      }
    }

    return this;
  };

  Modal.prototype.addFooterBtn = function(label, cssClass, callback) {
    var btn = document.createElement("button");

    // set label
    btn.innerHTML = label;

    // bind callback
    btn.addEventListener("click", callback);

    if (typeof cssClass === "string" && cssClass.length) {
      // add classes to btn
      cssClass.split(" ").forEach(function(item) {
        btn.classList.add(item);
      });
    }

    this.modalBoxFooter.appendChild(btn);

    return btn;
  };

  Modal.prototype.resize = function() {
    // eslint-disable-next-line no-console
    console.warn("Resize is deprecated and will be removed in version 1.0");
  };

  Modal.prototype.isOverflow = function() {
    var viewportHeight = window.innerHeight;
    var modalHeight = this.modalBox.clientHeight;

    return modalHeight >= viewportHeight;
  };

  Modal.prototype.checkOverflow = function() {
    // only if the modal is currently shown
    if (this.modal.classList.contains("tingle-modal--visible")) {
      if (this.isOverflow()) {
        this.modal.classList.add("tingle-modal--overflow");
      } else {
        this.modal.classList.remove("tingle-modal--overflow");
      }

      // tODO: remove offset
      // _offset.call(this);
      if (!this.isOverflow() && this.opts.stickyFooter) {
        this.setStickyFooter(false);
      } else if (this.isOverflow() && this.opts.stickyFooter) {
        _recalculateFooterPosition.call(this);
        this.setStickyFooter(true);
      }
    }
  };

  /* ----------------------------------------------------------- */
  /* == private methods */
  /* ----------------------------------------------------------- */

  function closeIcon() {
    return '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 21.9 21.9" enable-background="new 0 0 21.9 21.9" width="16px" height="16px"><path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z" fill="#000000"/></svg>';
  }

  function _recalculateFooterPosition() {
    if (!this.modalBoxFooter) {
      return;
    }
    this.modalBoxFooter.style.width = this.modalBox.clientWidth + "px";
    this.modalBoxFooter.style.left = this.modalBox.offsetLeft + "px";
  }

  function _build() {
    // wrapper
    this.modal = document.createElement("div");
    this.modal.classList.add("tingle-modal");

    // remove cusor if no overlay close method
    if (
      this.opts.closeMethods.length === 0 ||
      this.opts.closeMethods.indexOf("overlay") === -1
    ) {
      this.modal.classList.add("tingle-modal--noOverlayClose");
    }

    this.modal.style.display = "none";

    // custom class
    this.opts.cssClass.forEach(function(item) {
      if (typeof item === "string") {
        this.modal.classList.add(item);
      }
    }, this);

    // close btn
    if (this.opts.closeMethods.indexOf("button") !== -1) {
      this.modalCloseBtn = document.createElement("button");
      this.modalCloseBtn.type = "button";
      this.modalCloseBtn.setAttribute("id", "tingle-modal__close");
      this.modalCloseBtn.setAttribute("aria-label", "Close Modal Button");
      this.modalCloseBtn.classList.add("tingle-modal__close");

      this.modalCloseBtnIcon = document.createElement("span");
      this.modalCloseBtnIcon.classList.add("tingle-modal__closeIcon");
      if (this.opts.closeIconInverse) {
        this.modalCloseBtnIcon.classList.add("inverse-close-icon");
      }
      if (this.opts.closeIconLight) {
        this.modalCloseBtn.classList.add("tingle-modal__close--light");
      }
      //this.modalCloseBtnIcon.innerHTML = closeIcon();

      this.modalCloseBtnLabel = document.createElement("span");
      this.modalCloseBtnLabel.classList.add("tingle-modal__closeLabel");
      this.modalCloseBtnLabel.innerHTML = this.opts.closeLabel;

      this.modalCloseBtn.appendChild(this.modalCloseBtnIcon);
      this.modalCloseBtn.appendChild(this.modalCloseBtnLabel);
    }

    // modal
    this.modalBox = document.createElement("div");
    this.modalBox.setAttribute("id", "tingle-modal-box");
    this.modalBox.classList.add("tingle-modal-box");
    this.modalBox.setAttribute("role", "dialog");
    this.modalBox.setAttribute("aria-modal", "true");
    this.modalBox.setAttribute("aria-hidden", "false");
    document.getElementById("page__wrapper").setAttribute("aria-hidden", "true");
    
    if (this.opts.arialabelledby) {
      this.modalBox.setAttribute("aria-labelledby", this.opts.arialabelledby);
    }

    if (this.opts.ariadescribedby) {
      this.modalBox.setAttribute("aria-describedby", this.opts.ariadescribedby);
    }
    
    // modal box content
    this.modalBoxContent = document.createElement("div");
    this.modalBoxContent.classList.add("tingle-modal-box__content");

    this.modalBox.appendChild(this.modalBoxContent);

    if (this.opts.closeMethods.indexOf("button") !== -1) {
      this.modalBox.appendChild(this.modalCloseBtn);
    }

    this.modal.appendChild(this.modalBox);
  }

  function _buildFooter() {
    this.modalBoxFooter = document.createElement("div");
    this.modalBoxFooter.classList.add("tingle-modal-box__footer");
    this.modalBox.appendChild(this.modalBoxFooter);
  }

  function _bindEvents() {
    this._events = {
      clickCloseBtn: this.close.bind(this),
      clickOverlay: _handleClickOutside.bind(this),
      resize: this.checkOverflow.bind(this),
      keyboardNav: _handleKeyboardNav.bind(this)
    };

    if (this.opts.closeMethods.indexOf("button") !== -1) {
      this.modalCloseBtn.addEventListener("click", this._events.clickCloseBtn);
    }

    this.modal.addEventListener("mousedown", this._events.clickOverlay);
    window.addEventListener("resize", this._events.resize);
    document.addEventListener("keydown", this._events.keyboardNav);
  }

  function _handleKeyboardNav(event) {
    // escape key
    if (
      this.opts.closeMethods.indexOf("escape") !== -1 &&
      event.which === 27 &&
      this.isOpen()
    ) {
      this.close();
    }

    var isTabPressed = event.key === 'Tab' || event.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    //focus
    var focusableElements = 'iframe, button, [href], input:not(.pop-up-csf__container-form--demo-exp .contact-form-exp-field, .pop-up-csf__container-form--exp .contact-form-exp-field), select, textarea, [tabindex]:not([tabindex="-1"]',
    focusableElementsSel = this.modal.querySelectorAll(focusableElements),
    focusableContent = [];

    for (var index = 0; index < focusableElementsSel.length; index++) {
      if (!focusableElementsSel[index].closest(".hide")) {
        focusableContent.push(focusableElementsSel[index]);
      }
    }

    if (focusableContent.length > 0) {
      var firstFocusableElement = focusableContent[0], // get first element to be focused inside modal
      lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

      if (event.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          event.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          event.preventDefault();
        }
      }
    }
  }

  function _handleClickOutside(event) {
    // if click is outside the modal
    if (
      this.opts.closeMethods.indexOf("overlay") !== -1 &&
      !_findAncestor(event.target, "tingle-modal") &&
      event.clientX < this.modal.clientWidth
    ) {
      //this.close();
    }
  }

  function _findAncestor(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  function _unbindEvents() {
    if (this.opts.closeMethods.indexOf("button") !== -1) {
      this.modalCloseBtn.removeEventListener(
        "click",
        this._events.clickCloseBtn
      );
    }
    if (this.modal) {
      this.modal.removeEventListener("mousedown", this._events.clickOverlay);
    }
    window.removeEventListener("resize", this._events.resize);
    document.removeEventListener("keydown", this._events.keyboardNav);
  }

  /* ----------------------------------------------------------- */
  /* == helpers */
  /* ----------------------------------------------------------- */

  function extend() {
    for (var i = 1; i < arguments.length; i++) {
      for (var key in arguments[i]) {
        if (arguments[i].hasOwnProperty(key)) {
          arguments[0][key] = arguments[i][key];
        }
      }
    }
    return arguments[0];
  }

  /* ----------------------------------------------------------- */
  /* == return */
  /* ----------------------------------------------------------- */

  return {
    modal: Modal
  };
});
